module.exports = __webpack_public_path__ + "img/general-ambrose-burnside.1cf62c38.png";